export default function ProductBanner() {
  return (
    <div>
      <div>
        <div>
          <a
            href="https://www.flipkart.com/pages/10_day_returns_lifestyle"
            to="https://www.flipkart.com/pages/10_day_returns_lifestyle"
          >
            <div style={{ padding: "10px 0" }}>
              <img
                style={{ maxWidth: "100%" }}
                alt=""
                src="https://rukminim1.flixcart.com/www/2732/193/promos/01/12/2018/8aa01ab4-de88-4a46-9d93-5c7f3ebac2df.png?q=50"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
